import { DateFilterEnum } from '@/enums'
import { PersonalizationEngineModels } from '@/state/personalization-engine'
import { DatePeriodPickerComponent } from '@/views/components'

type Props = {
  date: DateFilterEnum
  filters: PersonalizationEngineModels.PersonalizationEngineFiltersType
  handleChangeDate: (newDate: DateFilterEnum) => void
  onChangeStartDate: (newDate: Date) => void
  onChangeEndDate: (newDate: Date) => void
}

export const DateFilterComponent = ({
  date,
  filters,
  handleChangeDate,
  onChangeEndDate,
  onChangeStartDate,
}: Props) => {
  return (
    <DatePeriodPickerComponent
      date={date}
      startDate={new Date(filters.startDate)}
      endDate={new Date(filters.endDate)}
      onChangeStartDate={onChangeStartDate}
      onChangeEndDate={onChangeEndDate}
      handleChangeDate={handleChangeDate}
    />
  )
}
